
import {
  Component,
  forwardRef,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  ControlValueAccessor,
  Validator,
  AbstractControl,
  ValidationErrors,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@uw/shared/shared.module';
import { passwordMatchValidator } from '@uw/shared/validators/password-match.validator';
import { PasswordComponent } from '../password/password.component';

@Component({
    selector: 'uw-password-registration',
    imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule
],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PasswordRegistrationComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PasswordRegistrationComponent),
            multi: true,
        },
    ],
    templateUrl: './password-registration.component.html',
    styleUrl: './password-registration.component.scss'
})
export class PasswordRegistrationComponent
  implements ControlValueAccessor, Validator
{
  passwordForm: FormGroup<{
    password: FormControl<string>;
    confirmPassword: FormControl<string>;
  }>;

  @ViewChildren(PasswordComponent)
  passwordComponents!: QueryList<PasswordComponent>;

  @Input()
  passwordLabel: string;

  onTouched: () => void = () => {};

  constructor(private fb: FormBuilder) {
    this.passwordForm = this.fb.nonNullable.group(
      {
        password: this.fb.nonNullable.control(null),
        confirmPassword: this.fb.nonNullable.control(null),
      },
      { validators: passwordMatchValidator() }
    );
  }


  // Automatically mark all child controls as touched when the 
  // parent form calls markAllAsTouched().
  // This is needed as parent form controls markAllAsTouched does 
  // not mark the child controls as touched.
  markAllControlsAsTouched(): void {
    Object.values(this.passwordForm.controls).forEach((control) => {
      control.markAsTouched();

      if (this.passwordComponents) {
        this.passwordComponents.forEach((passwordFormComponent) => {
          passwordFormComponent.markAsTouched();
        });
      }
    });
    this.onTouched(); // Notify the parent form that it was touched
  }

  writeValue(val: any): void {
    if (val) {
      this.passwordForm.setValue(val as { password: string; confirmPassword: string }, { emitEvent: false });
    } else {
      this.passwordForm.reset();
    }
  }

  registerOnChange(fn: any): void {
    this.passwordForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return this.passwordForm.valid
      ? null
      : { passwordRegistrationFormInvalid: true };
  }

}
